module.exports = __webpack_public_path__ + "img/about/80243-026.png";


//////////////////
// WEBPACK FOOTER
// ./img/about/80243-026.png
// module id = 28
// module chunks = 0